import { message } from 'antd';
import type { NavigateFunction } from 'react-router-dom';
import type { TenantOrder } from '@/mocks/orders';
import { ROUTES } from '@/constants/routes';
import { buildCopyOrderItems } from './buildCopyOrderItems';
import { mapOrderToPosPrefill } from './mapOrderToPosPrefill';

/**
 * Lõi dùng CHUNG cho action "Sao chép đơn hàng" — cả nút trên trang chi tiết
 * (`detail.tsx`) lẫn menu "..." của danh sách (`index.tsx`) đều gọi hàm này để
 * không có hai bản khác nhau của cùng một hợp đồng mồi POS (`copyFromOrder`).
 *
 * Caller tự lo trạng thái loading của UI mình (Button `loading` ở trang chi
 * tiết, `message.loading` ở danh sách) — hàm này chỉ lo phần lookup + điều
 * hướng + thông báo.
 */
export async function copyOrderToPos(order: TenantOrder, navigate: NavigateFunction): Promise<void> {
  try {
    const { orderItems, skipped } = await buildCopyOrderItems(order);
    if (skipped.length > 0) {
      // Dòng tra không ra bị BỎ, không mang sang giỏ ở dạng "đoán" — nhưng
      // phải nói rõ dòng nào, nếu không thu ngân thu thiếu cả một sản phẩm.
      message.warning(
        `Không sao chép được ${skipped.length} sản phẩm (ngừng bán/đổi mã): ${skipped.join(', ')}. Vui lòng thêm lại thủ công.`,
      );
    }
    navigate(ROUTES.pos, {
      state: { copyFromOrder: mapOrderToPosPrefill(order, orderItems) },
    });
  } catch {
    // Lookup hỏng (mất mạng/BE lỗi) thì KHÔNG điều hướng: mở POS với giỏ rỗng
    // trông y hệt sao chép thành công một đơn không có hàng.
    message.error('Không tải được thông tin sản phẩm để sao chép. Vui lòng thử lại.');
  }
}
